import { useState } from 'react';
import styled from '@emotion/styled';
import { HelmetHead } from '~/components/common';
import { breakpoint } from '~/styles/themes';
import { ChatLayoutHeader } from '../ChatConcept';
import MysteryLayout from './MysteryLayout';

export default function Mystery() {
  const [isChatHistoryOpen, setIsChatHistoryOpen] = useState(false);
  return (
    <>
      <HelmetHead title='Mystery Chat' />
      <ChatLayoutHeader setChatHistoryOpen={() => setIsChatHistoryOpen(true)} />
      <Container>
        <MysteryLayout
          setIsChatHistoryOpen={setIsChatHistoryOpen}
          isChatHistoryOpen={isChatHistoryOpen}
        />
      </Container>
    </>
  );
}

export const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  max-width: ${breakpoint.mobile_large};
  height: 100%;
  margin: 0 auto;
`;
